import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <React.Fragment>
      <footer className="site-footer">
        <div className="container">
          <p className="copyright-text">
            {" "}
          جميع حقوق النشر والتوزيع محفوظة لموقع أعمال سوفت وير 
            &copy; 2025
          </p>
          {/* <div className="row"> 
            <div className="col-sm-12 col-md-6">
              <h6>المهمة والرؤية</h6>
              <p className="text-justify">                 
                موقع أعمال سوفت وير” منصة لعرض وتشغيل خدمة إستخدام برامج أعمال
                المعتمدة على تقنية SaaS مما يتيح تجربة مميزة للعملاء في استخدام
                البرامج لإنجاز مهامهم اليومية سواء للأفراد او أعمال المكاتب أو
                الشركات متناهية الصغر والصغيرة" . مجموعة من البرمجيات مبنية على
                SaaS تكنولوجي التي يستخدمها العملاء لتسهيل أعمالهم اليومية
                سنساعدك على إدارة مهام أعمالك بأعلى كفاءة ، من أي مكان وفي أي
                وقت وبأقل التكاليف.
              </p>
            </div>
    
            <div className="col-xs-6 col-md-3">
              <h6>التطبيقات</h6>
              <ul className="footer-links">
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <a href="h">اعمال النقديه</a>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <a href="h">أعمال المحاماه</a>
                </li>
              </ul>
            </div>

            <div className="col-xs-6 col-md-3">
              <h6>سياسة الخصوصية</h6>
              <ul className="footer-links">
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <a href="/">أعمال النقدية </a>
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <a href="h/">أعمال المحاماه</a>
                </li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-6 col-xs-12">
              <p className="copyright-text">
                {" "}
                جميع حقوق النشر والتوزيع محفوظة لشركةإيارو لتكنولوجيا المعلومات
                &copy; 2023
              </p>       
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12">
              <ul className="social-icons">
                <li>
                  <a className="facebook" href="#d">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a className="twitter" href="#d">
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a className="dribbble" href="#d">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      </footer>
    </React.Fragment>
  );
};
export default Footer;
